// MG Product Swatches export: page Swatch Picker sections
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-FCP"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 3,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 12,
      "image_radius_px": 160,
      "product_image_padding": 1,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h2>Color Options</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 6,
      "swatches_per_row": 6,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Snow",
          "alt": "Snow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch_SNOW.png?v=1780422570",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-20_09c34002-1457-4a03-a822-73b9c58898f7.png?v=1767020802&width=400",
          "product_url": "/products/rfp-snow",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-snow",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moonlit",
          "alt": "Moonlit",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch_MOON.png?v=1780422614",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/FCP32_MOON_2D.png?v=1779895889&width=400",
          "product_url": "/products/rfp-moonlit",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-moonlit",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Ivory Tower",
          "alt": "Ivory Tower",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ivory-tower.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_1d74b5b9-2243-4695-9070-e9960e6816a9.png?v=1768853774&width=400",
          "product_url": "/products/rfp-ivorytower",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-ivorytower",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Alabaster",
          "alt": "Alabaster",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/alabaster.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_92f5b637-9a0e-4c87-acb7-e40fc6c08b15.png?v=1768853973&width=400",
          "product_url": "/products/rfp-alabaster",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-alabaster",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dove Grey",
          "alt": "Dove Grey",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/dove-grey.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-05_56a8701c-4b69-401b-9464-3f4ca8c37b07.png?v=1767019007&width=400",
          "product_url": "/products/rfp-dovegrey",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-dovegrey",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Willow",
          "alt": "Willow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/willow-clean.png?v=1647279531",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/willowandwhiteoak4.png?v=1780337381&width=400",
          "product_url": "/products/rfp-willow",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-willow",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Beige",
          "alt": "French Beige",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/french-beige.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-06_7a384c04-f75c-476b-83a9-015f9f40db14.png?v=1767019224&width=400",
          "product_url": "/products/rfp-frenchbeige",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-frenchbeige",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Lily",
          "alt": "Lily",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-LILY-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DS_LILY_Kit32-DarkWax_3642311a-046f-4cc5-b957-92f3725c92c1.png?v=1780431491&width=400",
          "product_url": "/products/rfp-lily",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-lily",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Greystone",
          "alt": "Greystone",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/greystone.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-08_4cc6497d-4d53-4f8e-861d-6890a6151d54.png?v=1767019447&width=400",
          "product_url": "/products/rfp-greystone",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-greystone",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Misty River",
          "alt": "Misty River",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-MIST-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_766da41b-c060-4106-9121-5269ca093aa3.png?v=1768855165&width=400",
          "product_url": "/products/rfp-mistyriver",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-mistyriver",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Olive Branch",
          "alt": "Olive Branch",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-OLIV-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_cb04081d-0f11-46c3-af8f-569df4cc419b.png?v=1768854996&width=400",
          "product_url": "/products/rfp-olivebranch",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-olivebranch",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Meadow Path",
          "alt": "Meadow Path",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/meadow-path.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-15_5dff1bdf-826c-487b-a80c-77c22e57022d.png?v=1767020212&width=400",
          "product_url": "/products/rfp-meadowpath",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-meadowpath",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Arabian Coffee",
          "alt": "Arabian Coffee",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/arabian-coffee.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-01_80be3528-d1e1-4a0d-acaf-33508c63cb8f.png?v=1775233163&width=400",
          "product_url": "/products/rfp-arabiancoffee",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-arabiancoffee",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Peacock",
          "alt": "Peacock",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch_PCOK.png?v=1780422588",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_PCOK_2D-32oz.png?v=1779897937&width=400",
          "product_url": "/products/rfp-peacock",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-peacock",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Twilight",
          "alt": "Twilight",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/twilight.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-24_5937dada-76fa-48db-9e6d-775dc1798589.png?v=1767021181&width=400",
          "product_url": "/products/rfp-twilight",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-twilight",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gothic Grey",
          "alt": "Gothic Grey",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/gothic-grey.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-07_d2eff9ab-65ad-4d9e-8493-6d0e349f30fa.png?v=1767019313&width=400",
          "product_url": "/products/rfp-gothicgrey",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-gothicgrey",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Midnight Black",
          "alt": "Midnight Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/midnight-black.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-12_f54f2786-789b-4c92-8b98-83dd13970810.png?v=1767019976&width=400",
          "product_url": "/products/rfp-midnightblack",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-midnightblack",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_appearance_source": "custom",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#000000",
          "preset_button_border_size": 20,
          "preset_button_shadow_size": 0,
          "preset_button_border_radius_px": 12,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#ffffff",
          "preset_button_gradient_angle": 180,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 0,
          "preset_button_text_size_desktop": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 12,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/FCP-View-All-Swatch-x400.png?v=1777980353&width=1600",
          "button_image_alt": "Retique It® Chalk Paint color swatches in assorted neutral and pastel shades.",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/FCP-View-All-Swatch-x400.png?v=1777980353&width=1600",
          "preset_button_image_alt": "Retique It® Chalk Paint color swatches in assorted neutral and pastel shades.",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Viridian",
          "alt": "Viridian",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/viridian.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-25_a6d2a7b3-cfa1-4b4b-bd34-cc9abfd56377.png?v=1767021293&width=400",
          "product_url": "/products/rfp-viridian",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-viridian",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gypsum",
          "alt": "Gypsum",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/gypsum.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-09_6f02abc4-70bb-4d35-bb73-5a4dd039895e.png?v=1767019605&width=400",
          "product_url": "/products/rfp-gypsum",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-gypsum",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Naples Yellow",
          "alt": "Naples Yellow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/naples-yellow.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_2a62e477-d382-4c76-b487-b00f23be5683.png?v=1768855412&width=400",
          "product_url": "/products/rfp-naplesyellow",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-naplesyellow",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sugar Pine",
          "alt": "Sugar Pine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-SUGA-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/FCP32_SUGA_2D.png?v=1780435705&width=400",
          "product_url": "/products/rfp-sugarpine",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-sugarpine",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Argentine",
          "alt": "Argentine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/argentine.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/argentineandblackwalnut2.png?v=1780416101&width=400",
          "product_url": "/products/rfp-argentine",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-argentine",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Stone Castle",
          "alt": "Stone Castle",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/stone-castle.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_f443175c-9cb0-459a-bc41-096bd22a3b90.png?v=1768855340&width=400",
          "product_url": "/products/rfp-stonecastle",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-stonecastle",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Tranquility",
          "alt": "Tranquility",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/tranquility.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-23_761cb8ad-b566-4c4e-8863-51de4c7658c9.png?v=1767021093&width=400",
          "product_url": "/products/rfp-tranquility",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-tranquility",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Ultramarine",
          "alt": "Ultramarine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ultramarine.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/RETQ-32-Primary-Web-Swatch_3edd44c9-ffbb-4556-8d4b-6eb617b9b499.jpg?v=1775233807&width=400",
          "product_url": "/products/rfp-ultramarine",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-ultramarine",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Indigo",
          "alt": "Black Indigo",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/black-indigo.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/RETQ-32-Primary-Web-Swatch_0e1cf700-556f-4a2d-a26d-f8d159fdc5b5.jpg?v=1775231779&width=400",
          "product_url": "/products/rfp-blackindigo",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-blackindigo",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Linen",
          "alt": "Old Linen",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/old-linen.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_1bf872a6-7430-4f0c-b72c-60bd57638561.png?v=1775236249&width=400",
          "product_url": "/products/rfp-oldlinen",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-oldlinen",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry Blossom",
          "alt": "Cherry Blossom",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/cherry-blossom.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_e72207ea-8ed3-43af-99ce-4db90e8fa03b.png?v=1768857255&width=400",
          "product_url": "/products/rfp-cherryblossom",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-cherryblossom",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Venetian Red",
          "alt": "Venetian Red",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/venetian-red.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-26_e4166cf6-b2a7-4a81-a174-80b07c05a0f6.png?v=1767021435&width=400",
          "product_url": "/products/rfp-venetianred",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-venetianred",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Mystic Moss",
          "alt": "Mystic Moss",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/mystic-moss.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/RETQ-32-Primary-Web-Swatch_fee749e3-b4fe-470e-bc35-b4b8c4b12472.jpg?v=1775236443&width=400",
          "product_url": "/products/rfp-mysticmoss",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-mysticmoss",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pumpkin",
          "alt": "Pumpkin",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/pumpkin.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/RETQ-32-Primary-Web-Square_799b3a54-0bdd-4ee8-b874-5523335643bf.jpg?v=1751989119&width=400",
          "product_url": "/products/rfp-pumpkin",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-pumpkin",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-FCP32"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 12,
      "image_radius_px": 160,
      "product_image_padding": 3,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 12,
      "image_radius_px": 160,
      "product_image_padding": 1,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h2>Color Options</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 6,
      "swatches_per_row": 6,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Snow",
          "alt": "Snow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch_SNOW.png?v=1780422570",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-20_09c34002-1457-4a03-a822-73b9c58898f7.png?v=1767020802&width=400",
          "product_url": "/products/fcp-snow-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-snow-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moonlit",
          "alt": "Moonlit",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch_MOON.png?v=1780422614",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-20_09c34002-1457-4a03-a822-73b9c58898f7.png?v=1767020802&width=400",
          "product_url": "/products/fcp-snow-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-snow-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Ivory Tower",
          "alt": "Ivory Tower",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ivory-tower.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_1d74b5b9-2243-4695-9070-e9960e6816a9.png?v=1768853774&width=400",
          "product_url": "/products/fcp-ivorytower-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-ivorytower-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Alabaster",
          "alt": "Alabaster",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/alabaster.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_92f5b637-9a0e-4c87-acb7-e40fc6c08b15.png?v=1768853973&width=400",
          "product_url": "/products/fcp-alabaster-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-alabaster-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dove Grey",
          "alt": "Dove Grey",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/dove-grey.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-05_56a8701c-4b69-401b-9464-3f4ca8c37b07.png?v=1767019007&width=400",
          "product_url": "/products/fcp-dovegrey-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-dovegrey-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Willow",
          "alt": "Willow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/willow-clean.png?v=1647279531",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-05_226d2ed0-2f62-41e5-b676-2ef4e101e022.png?v=1775251340&width=400",
          "product_url": "/products/fcp-willow-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-willow-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Beige",
          "alt": "French Beige",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/french-beige.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-06_7a384c04-f75c-476b-83a9-015f9f40db14.png?v=1767019224&width=400",
          "product_url": "/products/fcp-frenchbeige-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-frenchbeige-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Lily",
          "alt": "Lily",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-LILY-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_f17682f4-9a98-4aff-b595-7fe7781dec65.png?v=1768854605&width=400",
          "product_url": "/products/fcp-lily-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-lily-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Greystone",
          "alt": "Greystone",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/greystone.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-08_4cc6497d-4d53-4f8e-861d-6890a6151d54.png?v=1767019447&width=400",
          "product_url": "/products/fcp-greystone-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-greystone-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Misty River",
          "alt": "Misty River",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-MIST-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_766da41b-c060-4106-9121-5269ca093aa3.png?v=1768855165&width=400",
          "product_url": "/products/rfp-mistyriver",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/rfp-mistyriver",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Olive Branch",
          "alt": "Olive Branch",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-OLIV-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_cb04081d-0f11-46c3-af8f-569df4cc419b.png?v=1768854996&width=400",
          "product_url": "/products/fcp-olivebranch-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-olivebranch-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Meadow Path",
          "alt": "Meadow Path",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/meadow-path.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-15_5dff1bdf-826c-487b-a80c-77c22e57022d.png?v=1767020212&width=400",
          "product_url": "/products/fcp-meadowpath-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-meadowpath-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Arabian Coffee",
          "alt": "Arabian Coffee",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/arabian-coffee.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/B06VWV5C4M.PT09.jpg?v=1775233163&width=400",
          "product_url": "/products/fcp-arabiancoffee-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-arabiancoffee-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Twilight",
          "alt": "Twilight",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/twilight.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-24_5937dada-76fa-48db-9e6d-775dc1798589.png?v=1767021181&width=400",
          "product_url": "/products/fcp-twilight-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-twilight-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Midnight Black",
          "alt": "Midnight Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/midnight-black.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-12_f54f2786-789b-4c92-8b98-83dd13970810.png?v=1767019976&width=400",
          "product_url": "/products/fcp-midnightblack-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-midnightblack-l",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_appearance_source": "custom",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#000000",
          "preset_button_border_size": 20,
          "preset_button_shadow_size": 0,
          "preset_button_border_radius_px": 12,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#ffffff",
          "preset_button_gradient_angle": 180,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 0,
          "preset_button_text_size_desktop": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 12,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Viridian",
          "alt": "Viridian",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/viridian.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-25_a6d2a7b3-cfa1-4b4b-bd34-cc9abfd56377.png?v=1767021293&width=400",
          "product_url": "/products/fcp-viridian-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-viridian-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gypsum",
          "alt": "Gypsum",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/gypsum.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-09_6f02abc4-70bb-4d35-bb73-5a4dd039895e.png?v=1767019605&width=400",
          "product_url": "/products/fcp-gypsum-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-gypsum-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Naples Yellow",
          "alt": "Naples Yellow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/naples-yellow.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_2a62e477-d382-4c76-b487-b00f23be5683.png?v=1768855412&width=400",
          "product_url": "/products/fcp-naplesyellow-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-naplesyellow-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sugar Pine",
          "alt": "Sugar Pine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-SUGA-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/1432041120-3cfb84807657c720545ea9e260817f3132794a30f4b252d8a1d8b20be37f113f-d_295x166_53935a4b-354b-4d65-813f-2ec4be910290.jpg?v=1667403834&width=400",
          "product_url": "/products/countertopkit_java_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/countertopkit_java_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Argentine",
          "alt": "Argentine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/argentine.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-03_b6b3bb5e-4a9e-4c67-9ca5-9ed235ff4b27.png?v=1775232205&width=400",
          "product_url": "/products/fcp-argentine-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-argentine-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Stone Castle",
          "alt": "Stone Castle",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/stone-castle.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_f443175c-9cb0-459a-bc41-096bd22a3b90.png?v=1768855340&width=400",
          "product_url": "/products/fcp-stonecastle-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-stonecastle-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gothic Grey",
          "alt": "Gothic Grey",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/gothic-grey.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-07_d2eff9ab-65ad-4d9e-8493-6d0e349f30fa.png?v=1767019313&width=400",
          "product_url": "/products/fcp-gothicgrey-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-gothicgrey-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Tranquility",
          "alt": "Tranquility",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/tranquility.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-23_761cb8ad-b566-4c4e-8863-51de4c7658c9.png?v=1767021093&width=400",
          "product_url": "/products/fcp-tranquility-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-tranquility-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Ultramarine",
          "alt": "Ultramarine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ultramarine.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/RETQ-32-Primary-Web-Swatch_3edd44c9-ffbb-4556-8d4b-6eb617b9b499.jpg?v=1775233807&width=400",
          "product_url": "/products/fcp-ultramarine-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-ultramarine-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Indigo",
          "alt": "Black Indigo",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/black-indigo.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/RETQ-32-Primary-Web-Swatch_0e1cf700-556f-4a2d-a26d-f8d159fdc5b5.jpg?v=1775231779&width=400",
          "product_url": "/products/fcp-blackindigo-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-blackindigo-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Linen",
          "alt": "Old Linen",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/old-linen.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-02_1bf872a6-7430-4f0c-b72c-60bd57638561.png?v=1775236249&width=400",
          "product_url": "/products/fcp-oldlinen-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-oldlinen-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Venetian Red",
          "alt": "Venetian Red",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/venetian-red.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-26_e4166cf6-b2a7-4a81-a174-80b07c05a0f6.png?v=1767021435&width=400",
          "product_url": "/products/fcp-venetianred-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-venetianred-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Mystic Moss",
          "alt": "Mystic Moss",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/mystic-moss.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/RETQ-32-Primary-Web-Swatch_fee749e3-b4fe-470e-bc35-b4b8c4b12472.jpg?v=1775236443&width=400",
          "product_url": "/products/fcp-mysticmoss-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-mysticmoss-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pumpkin",
          "alt": "Pumpkin",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/pumpkin.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/RETQ-32-Primary-Web-Square_799b3a54-0bdd-4ee8-b874-5523335643bf.jpg?v=1751989119&width=400",
          "product_url": "/products/fcp-pumpkin-l",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/fcp-pumpkin-l",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-FCPpkit"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 12,
      "image_radius_px": 160,
      "product_image_padding": 3,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 12,
      "image_radius_px": 160,
      "product_image_padding": 1,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h2>Color Options</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Snow",
          "alt": "Snow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch_SNOW.png?v=1780422570",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moonlit",
          "alt": "Moonlit",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch_MOON.png?v=1780422614",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Ivory Tower",
          "alt": "Ivory Tower",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ivory-tower.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Alabaster",
          "alt": "Alabaster",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/alabaster.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dove Grey",
          "alt": "Dove Grey",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/dove-grey.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Willow",
          "alt": "Willow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/willow-clean.png?v=1647279531",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Beige",
          "alt": "French Beige",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/french-beige.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Lily",
          "alt": "Lily",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-LILY-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Greystone",
          "alt": "Greystone",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/greystone.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Misty River",
          "alt": "Misty River",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-MIST-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Olive Branch",
          "alt": "Olive Branch",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-OLIV-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Meadow Path",
          "alt": "Meadow Path",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/meadow-path.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Arabian Coffee",
          "alt": "Arabian Coffee",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/arabian-coffee.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Twilight",
          "alt": "Twilight",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/twilight.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Midnight Black",
          "alt": "Midnight Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/midnight-black.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_appearance_source": "custom",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#000000",
          "preset_button_border_size": 20,
          "preset_button_shadow_size": 0,
          "preset_button_border_radius_px": 12,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#ffffff",
          "preset_button_gradient_angle": 180,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 0,
          "preset_button_text_size_desktop": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 12,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Viridian",
          "alt": "Viridian",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/viridian.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gypsum",
          "alt": "Gypsum",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/gypsum.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Naples Yellow",
          "alt": "Naples Yellow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/naples-yellow.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sugar Pine",
          "alt": "Sugar Pine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-SUGA-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Argentine",
          "alt": "Argentine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/argentine.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Stone Castle",
          "alt": "Stone Castle",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/stone-castle.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gothic Grey",
          "alt": "Gothic Grey",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/gothic-grey.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Tranquility",
          "alt": "Tranquility",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/tranquility.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Ultramarine",
          "alt": "Ultramarine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ultramarine.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Indigo",
          "alt": "Black Indigo",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/black-indigo.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Linen",
          "alt": "Old Linen",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/old-linen.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Venetian Red",
          "alt": "Venetian Red",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/venetian-red.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Mystic Moss",
          "alt": "Mystic Moss",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/mystic-moss.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pumpkin",
          "alt": "Pumpkin",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/pumpkin.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-FCPwkit"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 12,
      "image_radius_px": 160,
      "product_image_padding": 3,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 12,
      "image_radius_px": 160,
      "product_image_padding": 1,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h2>Color Options</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Snow",
          "alt": "Snow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch_SNOW.png?v=1780422570",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moonlit",
          "alt": "Moonlit",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch_MOON.png?v=1780422614",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Ivory Tower",
          "alt": "Ivory Tower",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ivory-tower.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Alabaster",
          "alt": "Alabaster",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/alabaster.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dove Grey",
          "alt": "Dove Grey",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/dove-grey.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Willow",
          "alt": "Willow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/willow-clean.png?v=1647279531",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Beige",
          "alt": "French Beige",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/french-beige.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Lily",
          "alt": "Lily",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-LILY-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Greystone",
          "alt": "Greystone",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/greystone.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Misty River",
          "alt": "Misty River",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-MIST-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Olive Branch",
          "alt": "Olive Branch",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-OLIV-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Meadow Path",
          "alt": "Meadow Path",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/meadow-path.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Arabian Coffee",
          "alt": "Arabian Coffee",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/arabian-coffee.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Twilight",
          "alt": "Twilight",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/twilight.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Midnight Black",
          "alt": "Midnight Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/midnight-black.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_appearance_source": "custom",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#000000",
          "preset_button_border_size": 20,
          "preset_button_shadow_size": 0,
          "preset_button_border_radius_px": 12,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#ffffff",
          "preset_button_gradient_angle": 180,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 0,
          "preset_button_text_size_desktop": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 12,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Viridian",
          "alt": "Viridian",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/viridian.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gypsum",
          "alt": "Gypsum",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/gypsum.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Naples Yellow",
          "alt": "Naples Yellow",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/naples-yellow.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sugar Pine",
          "alt": "Sugar Pine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-FCP-SUGA-Swatch.png?v=1777928269",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Argentine",
          "alt": "Argentine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/argentine.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Stone Castle",
          "alt": "Stone Castle",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/stone-castle.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gothic Grey",
          "alt": "Gothic Grey",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/gothic-grey.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Tranquility",
          "alt": "Tranquility",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/tranquility.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Ultramarine",
          "alt": "Ultramarine",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ultramarine.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Indigo",
          "alt": "Black Indigo",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/black-indigo.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Linen",
          "alt": "Old Linen",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/old-linen.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Venetian Red",
          "alt": "Venetian Red",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/venetian-red.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Mystic Moss",
          "alt": "Mystic Moss",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/mystic-moss.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pumpkin",
          "alt": "Pumpkin",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/pumpkin.png",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "",
          "product_url": "",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};